import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useEventFilterTypes: any = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["filters", "events"],
    queryFn: getData,
  });

  if (data) {

    const filterTypes: {
      reg_types: any[],
      states: any[],
      types: any[],
      subtypes: any[],
      grounds: any[],
      event_hosts: any[];
      tags: any[];
    } = { reg_types: [], states: [], types: [], subtypes: [], grounds: [], event_hosts: [], tags: [] };

    filterTypes.reg_types = data.reg_types ?? [];
    filterTypes.states = data.states ?? [];
    filterTypes.grounds = data.grounds ?? [];
    filterTypes.event_hosts = data.event_hosts ?? [];
    filterTypes.tags = data.tags ?? [];

    (data.types ?? []).forEach((element: any) => {
      filterTypes.types.push({ id: element.type, name: element.type });

      element.subtypes?.forEach((subtype: any) => {
        if (!filterTypes.subtypes.find((sb) => sb.id == subtype)) {
          filterTypes.subtypes.push({ id: subtype, name: subtype });
        }
      });
    });

    return { data: filterTypes, isLoading, error };
  }


  return { data, isLoading, error };
};

const getData = async () => {
  const response = await axios.get(`/events/filters/`);
  return response.data;
};

export default useEventFilterTypes;

